import React from 'react';
import MuiListItemText from '@mui/material/ListItemText';

const ListItemText = (props) => <MuiListItemText {...props} />;

export default ListItemText;
